import Cookies from "js-cookie"
import { jwtDecode } from "jwt-decode";

const saveTokenToCookies = (token) => {
    Cookies.set('jwt', token, {
      expires: 1 / 24, // Token will expire in 1 Hour.
      secure: true, // Use HTTPS in production
      sameSite: 'strict', // Protect against CSRF
    });
};

const getTokenFromCookies = () => {
    const token = Cookies.get('jwt');
    return token || false;
};

const removeTokenFromCookies = () => {
  Cookies.remove('jwt');
  localStorage.removeItem("User")
  localStorage.removeItem("UserLoggedIn");
};
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);  
    if (exp <= currentTime) {
      return true;
    }
    else {
      return false  
    }
  } catch (err) {
    console.error('Invalid token', err);
    return true;
  }
};
export { saveTokenToCookies, getTokenFromCookies, removeTokenFromCookies, isTokenExpired };
  